let batchSequence = 0

export function createDefaultConfig() {
  return {
    face: {
      liveness_enabled: true,
      live_threshold: 0.8,
      match_threshold: 80,
      quality_threshold: 0.6,
      minimum_face_size_px: 120,
      stable_frames: 3,
      recognition_interval_ms: 1000,
      stranger_voice_enabled: true,
      enrollment_timeout_seconds: 30
    },
    fill_light: {
      strategy: 'face_detected',
      start_time: '07:00',
      end_time: '22:00',
      off_delay_seconds: 5
    },
    display: { brightness_percent: 80, keep_screen_on: true },
    speech: { media_volume_percent: 80 },
    speech_copy: {
      recognized: '识别成功',
      check_in_success: '签到成功',
      check_out_success: '签离成功',
      offline: '网络已断开',
      stranger: '未注册用户',
      liveness_failed: '活体检测失败',
      enrollment_success: '录入成功',
      enrollment_failed: '录入失败'
    },
    attendance_capture: {
      check_in_enabled: true,
      check_out_enabled: false
    }
  }
}

export function mergeConfigTemplate(template) {
  const defaults = createDefaultConfig()
  const source = template && typeof template === 'object' && !Array.isArray(template) ? template : {}
  Object.keys(defaults).forEach(group => {
    const sourceGroup = source[group]
    if (!sourceGroup || typeof sourceGroup !== 'object' || Array.isArray(sourceGroup)) return
    Object.keys(defaults[group]).forEach(field => {
      const sourceValue = sourceGroup[field]
      const defaultValue = defaults[group][field]
      if (!Object.prototype.hasOwnProperty.call(sourceGroup, field) || typeof sourceValue !== typeof defaultValue) return
      if (typeof sourceValue === 'number' && !Number.isFinite(sourceValue)) return
      defaults[group][field] = sourceValue
    })
  })
  return defaults
}

export function createBatchId() {
  batchSequence += 1
  return `cms_${Date.now().toString(36)}_${batchSequence.toString(36)}`
}

export function createSyncTask(deviceId) {
  return {
    deviceId,
    batchId: createBatchId(),
    running: true,
    lastUserId: '',
    created: 0,
    skipped: 0,
    batches: 0
  }
}

export function getEnabledDevices(devices) {
  return (Array.isArray(devices) ? devices : []).filter(item => Number(item.enabled) === 1)
}

export function normalizePageResult(data) {
  const result = data || {}
  return {
    count: Number(result.count) || 0,
    list: Array.isArray(result.list) ? result.list : []
  }
}

export function commandTypeText(type) {
  const labels = {
    'person.upsert': '同步人员',
    'person.delete': '删除人员',
    'config.update': '更新配置',
    'update.check': '检查更新'
  }
  return labels[type] || type || '-'
}

export function commandStatusText(status) {
  const labels = {
    pending: '等待发送',
    leased: '发送中',
    sent: '等待回执',
    retry_wait: '等待重试',
    acked_success: '执行成功',
    acked_failed: '执行失败',
    expired: '已过期'
  }
  return labels[status] || status || '-'
}
